import { Grid, Icon, IconButton, makeStyles, Typography } from "@material-ui/core"
import DeleteButton from "../../../../../../components/Actions/DeleteButton"
import RoundedButton from "../../../../../../components/Actions/RoundedButton"
import SimpleCard from "../../../../../../components/Structure/Cards/SimpleCard"


const useStyles = makeStyles(theme => ({
    rows:{
        marginTop:40
    },
    header:{
        font:theme.typography.fontFamily,
        fontSize:'0.875rem',
        color:'#909090',
        fontWeight:500
    },
}))

const ProviderTable = props => {

    const { content, rows, onAdd, onDelete, can_edit } = props
    const classes = useStyles()

    return(
        <SimpleCard>
            <Grid container justifyContent='space-between'>
                <Grid item>
                    <Typography variant='subtitle2'>{content.title}</Typography>
                </Grid>
                {can_edit ? <Grid item>
                    <RoundedButton onClick={onAdd} >{content.button}</RoundedButton>
                </Grid> : null}
            </Grid>
            {rows && rows.length ?
                <div className={classes.rows}>
                    <div className={classes.header}>
                    <Grid container spacing={3}>
                        <Grid item xs={1}>{content.id}</Grid>
                        <Grid item xs={3}>{content.name}</Grid>
                        <Grid item xs={3}>{content.contact}</Grid>
                        <Grid item xs={3}>{content.email}</Grid>
                        <Grid item xs>{content.phone}</Grid>
                    </Grid>
                    </div>
                    {rows.map(item => {
                        return(
                            <Row {...item} key={item.code} onDelete={can_edit ? ()=>onDelete(item.id_provider_product) : null} />
                        )
                    })}
                </div>
            : null}
        </SimpleCard>
    )
}

export default ProviderTable


const useStylesRow = makeStyles(theme => ({
    root:{
        borderBottom:'1px solid #D2D2D2',
        padding:'16px 0px',
        font:theme.typography.fontFamily,
        fontWeight:500
    },
    delete_button:{
        boxShadow:'0px 0px 2.86957px rgba(0, 0, 0, 0.25)',
        color:theme.palette.primary.main,
    },
}))

const Row = ({provider_id, provider_name, provider_contact_name, provider_contact_email, provider_contact_phone, onDelete}) => {

    const classes = useStylesRow()

    return(
        <div className={classes.root}>
            <Grid container spacing={3} alignItems='center'>
                <Grid item xs={1}>{provider_id}</Grid>
                <Grid item xs={3}>{provider_name}</Grid>
                <Grid item xs={3}>{provider_contact_name}</Grid>
                <Grid item xs={3}>{provider_contact_email}</Grid>
                <Grid item xs>{provider_contact_phone}</Grid>
                {onDelete ? <Grid item><DeleteButton onClick={onDelete} /></Grid> : null}
            </Grid>
        </div>
    )
}